
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import {applys, checkApplyUser } from '@/api/team/team'

@Component
export default class Member extends Vue {

    private dataList: object[] = [];
    private total: number | string = 0;
    private searchParams: object = {
        uid: '',
        page: 1,
        pagesize:20,
    };
    private columnsSchema: object[] = [
        {
            title: '头像',
            slot: 'url',
            align: 'center',
            width: 70,
        },
        {
            title: '用户ID',
            key: 'uid',
        },
        {
            title: '昵称',
            key: 'nick_name',
        },
        {
            title: '申请时间',
            slot: 'time',
            align: 'center',
        },
        {
            title: '操作',
            slot: 'operate',
            align: 'center',
            width: 120,
        },
    ];
    private created() {
        this.getList()
    }
    private async getList() {
        let params: any = JSON.parse(JSON.stringify(this.searchParams))
        try {
            const data = (await applys(params)) as any;
            this.$nextTick(() => {
                this.dataList = data.rows;
                this.total = data.total;

            });
        } catch (error) {
            console.log(error);
        }
    }

    // 搜索
    private handleSearch() {
        this.getList();
    }

    // 分页
    private changePage(data) {
        this.searchParams = Object.assign(this.searchParams, {
            page: data,
        });
        this.getList();
    }
    // 重置
    private handlereset() {
        this.searchParams = {
            uid: '',
            page: 1,
            pagesize:20,
        };
        this.getList();
    }

    //审核确认
    private handleCheckUser(row,status){
        this.$Modal.confirm({
            title: '审核确认',
            content: `您确定要【${status == 1 ? '通过' : '拒绝'}】用户【${row.nick_name}】吗?`,
            onOk: () => {
                this.checkUser(row.uid,status)
            },
        });
    }

    private async checkUser(uid,status){
        let res = await checkApplyUser({uid:uid,status: status})
        this.$store.dispatch('getTeam');
    }
}
